/*
 * 状态转换--枚举转换
 * 在此处定义--在main中引入--注册为全局的变量
 * 在相应的组件中直接使用--webengineer_gh@sina.com
 * */





/*账单类别*/
const bill_catogory = {
  '1': '佣金',
  '2': '工具',
  '3': '贷款'
}
const tabs_list_bussinss = [{
    id: 0,
    name: '厂商'
  },
  {
    id: 1,
    name: '品牌商'
  },
  {
    id: 2,
    name: '个人'
  },
]
const tabs_list_put = [{
    id: 0,
    name: '申请审核'
  },
  {
    id: 1,
    name: '预付款审核'
  },
  {
    id: 2,
    name: '尾款审核'
  },
]
const tabs_list_static = [{
    id: 0,
    name: '全部'
  },
  {
    id: 1,
    name: '待审核'
  },
  {
    id: 2,
    name: '审核通过'
  },
  {
    id: 3,
    name: '审核拒绝'
  },
]
const word_sensitive_static = [{
    id: 1,
    name: '开启'
  },
  {
    id: 2,
    name: '关闭'
  },
]
//订单状态
const orderType = [{
    label: "代付款",
    value: 1
  },
  {
    label: "代发货",
    value: 2
  },
  {
    label: "待收货",
    value: 3
  },
  {
    label: "已完成",
    value: 4
  },
  {
    label: "已取消",
    value: 5

  }
]
//订单管理 -商城订单
const payTime = [{
    label: "下单时间",
    value: "下单时间"

  },
  {
    label: "支付时间",
    value: "支付时间"

  }
]
//商品中心 -状态
const goodStatus = [{
    value: 1,
    label: '已上架'
  },
  {
    value: 0,
    label: '已下架'
  },
]
const upOrderStatus = [{
    id: 1,
    title: "待审核"
  },
  {
    id: 2,
    title: "待支付预付款"
  },
  {
    id: 3,
    title: "待上传物料"
  },
  {
    id: 4,
    title: "已上传物料"
  },
  {
    id: 5,
    title: "待支付尾款"
  },
  {
    id: 6,
    title: "已完成"
  },
  {
    id: 7,
    title: "已取消"
  },
  {
    id: 8,
    title: "审核失败"
  }
]
const point_options = [{
    value: '1',
    label: '订单编号'
  },
  {
    value: '2',
    label: '缴费卡号'
  },

  {
    value: '3',
    label: '用户账号'
  },
]
const point_status = [{
    value: '',
    label: '全部'
  },
  {
    value: '1',
    label: '待支付'
  },
  {
    value: '2',
    label: '已支付'
  },
  {
    value: '5',
    label: '已取消'
  },
  {
    value: '4',
    label: '已完成'
  },
]
const coup_point = [{
    value: 2,
    label: '卡券名称'
  },
  {
    value: 1,
    label: '订单编号'
  },
  {
    value: 3,
    label: '用户账号'
  },
]
const bill_options = [{
    value: 1,
    label: '活动名称'
  }, {
    value: 2,
    label: '快递单号'
  }, {
    value: 3,
    label: '联系人'
  }]
  //0=未开始，1=进行中，2=已结束，3=已关闭
const erw_options = [{
    value: 0,
    label: '未开始'
  }, {
    value: 1,
    label: '进行中'
  }, {
    value: 2,
    label: '已结束'
  },
  {
    value: 3,
    label: '已关闭'
  }
]
const bill_statusoptions = [ 
  { value: 1, label: '未邮寄'},
{ value: 2, label: '已邮寄' }
]
const tool_options = [ 
  { value: 1, label: '启用'},
{ value: 2, label: '禁用' }
]
const activation_options = [ 
  { value: 0, label: '异常'},
{ value: 1, label: '正常' }
]
// 优惠券设置：类型一筛选
const typeOneFiltering = [ 
  { value: 0, label: '全部'},
  { value: 60, label: '平台券'},
  { value: 10, label: '店铺全品券' },
  { value: 20, label: '店铺专用券' },
  ]
  // 优惠券设置：类型一筛选
  const typeTowFiltering = [ 
  { value: 0, label: '全部'},
  { value: 1, label: '满减券'},
  { value: 2, label: '立减券' },
  { value: 3, label: '折扣券' },
  ]
  /**  
  @使用
   <el-option :label="value" :value="key" v-for="(value, key, index) in GLOBALState['bill_catogory']" :key="index"></el-option>
  */
  /*性别*/
  const gender = {
    true: '男',
    false: '女'
  }
/**
 * @使用
 *<!--                                <*el-option :label="value" :value="!!key" v-for="(value, key, index) in GLOBALState['gender']" :key="index"></*  el-option>-->
 */




export default {
  bill_catogory,
  gender,
  tabs_list_bussinss,
  tabs_list_static,
  word_sensitive_static,
  orderType,
  payTime,
  goodStatus,
  upOrderStatus,
  point_options,
  point_status,
  coup_point,
  tabs_list_put,
  bill_options,
  bill_statusoptions,
  erw_options,
  tool_options,
  activation_options,
  typeOneFiltering,
  typeTowFiltering,
}